import {HTTP} from "../../helpers/axios";
import { Action } from 'redux'
import {RootState} from '../../reducers'
import { ThunkAction } from 'redux-thunk'
import { serverRoutes} from "../../api/serverRoutes";


export const getDealersDevicesAction = (data:object,callback:(error:boolean)=>void):ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch,getState) => {

    let error=false;

    try {
        const response =  await   HTTP(getState,dispatch).post(serverRoutes.getDealerDevices,data);


        dispatch({
            type: 'DEALER_DEVICES',
            payload: response.data
        });

        callback(error);
    }catch (e) {
        error=true;
        callback(error);
    }


};

